export const environment = {
 production: true,
 baseUrl:"https://staging.hrms-rails7.property-pistol.in/api/"
};
